// extracted by mini-css-extract-plugin
export default {"nav__main":"Navigation_nav__main__w3LWu"};